import React from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/Blog_Down.css";

import img from "../../Asserts/1.jpg";
import img1 from "../../Asserts/2.jpg";


// Blog data
const blogPosts = [
  {
    id: 1,
    category: "Quality Policy",
    title: "How AI is Revolutionizing the Tech Industry",
    image: img,
    author: "Shanti Electricals",
  },
  {
    id: 2,
    category: "Quality Policy",
    title: "Minimalist UI Trends That Shape Modern Websites",
    image: img,
    author: "Stahllform ",
    date: "August 22, 2025",
    authorAvatar: "https://randomuser.me/api/portraits/men/2.jpg",
  },
  {
    id: 3,
    category: "Certificate",
    title: "Top React Practices for Scalable Frontend Projects",
    image: img1,
    author: "Certificate of Appointment",
    date: "August 25, 2025",
    authorAvatar: "https://randomuser.me/api/portraits/women/3.jpg",
  },
  {
    id: 4,
    category: "Certificate",
    title: "Remote Work Tools Every Team Should Use in 2025",
    image: img1,
    author: "Schneider Electric",
    date: "August 27, 2025",
    authorAvatar: "https://randomuser.me/api/portraits/men/4.jpg",
  },
  {
    id: 5,
    category: "Certificate",
    title: "Effective Team Collaboration Strategies Today",
    image: img1,
    author: "SIEPAN 8PU Licensed",
    date: "August 29, 2025",
    authorAvatar: "https://randomuser.me/api/portraits/men/6.jpg",
  },
];


// Blog Card
const BlogCard = ({ post, onClick }) => (
  <div className="blog-card" onClick={onClick}>
    <div className="card-image-wrapper">
      <img src={post.image} alt={post.title} className="card-image" />
    </div>

    <div className="card-content">
      <span className="category-tag">{post.category}</span>

      <div className="author-info">

        <div className="author-details">
          <span className="author-name">{post.author}</span>
        </div>
      </div>
    </div>
  </div>
);


// Main Component
const Blog_Down = () => {
  const navigate = useNavigate();

  // Navigate based on card ID
  const handleCardClick = (id) => {
    navigate(`/Gallery_${id}`);
  };

  return (
    <section className="blog-grid-section">
      <h2 className="section-heading">Our Latest <span className="highlight-orange">Blog Posts</span></h2>

      <div className="blog-grid-container">
        {blogPosts.map((post) => (
          <BlogCard
            key={post.id}
            post={post}
            onClick={() => handleCardClick(post.id)}
          />
        ))}
      </div>
    </section>
  );
};

export default Blog_Down;
